import restApi from "@plannel/services/utils/rest-api";

const getSchedule = () => {
    return restApi.get("/api/quartz-schedule");
}

const getIPReleaseVersion = () => {
    return restApi.get("/api/quartz-schedule/ip-release-version");
}

const getDpTransformTargetData = (transformTarget, isOnlyRp) => {
    const params = { transformTarget, isOnlyRp };
    return restApi.get("/api/quartz-schedule/dp-target-data", { params });
}

const upsert = (data) => {
    return restApi.post("/api/quartz-schedule", data);
}

const remove = (ids) => {
    return restApi.delete(`/api/quartz-schedule/${ids}`);
}

const scheduleService = {
    getSchedule,
    getIPReleaseVersion,
    getDpTransformTargetData,
    upsert,
    remove
}

export default scheduleService;